import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React from "react"
import { TouchableOpacity, View } from "react-native"
import { Icon } from "react-native-paper"
import { SelectInputM } from "../../../student/account/onboarding/SelectInputM"

const SelectableRowWithInput = (props) => {
    const {
        item,
        title,
        icon,
        onRemove,
        selectOptions = [],
        selectedValue,
        onSelectChange,
        containerStyle = {},
        showRemoveButton = true,
        errors,
        name,
        selectLabel,
        selectPlaceholder,
    } = props

    return (
        <View
            style={{
                backgroundColor: theme.colors.white,
                borderRadius: theme.roundness,
                borderWidth: 1,
                borderColor: theme.colors.lightMore,
                padding: 12,
                marginBottom: 10,
                ...containerStyle,
            }}
        >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                {icon &&
                    (typeof icon === "string" ? (
                        <IconImageM uri={icon} width={24} height={24} />
                    ) : (
                        icon
                    ))}
                <TextM
                    fontSize={14}
                    fontWeight="Medium"
                    color={theme.colors.primary}
                    style={{ flex: 1, marginLeft: icon ? 10 : 0 }}
                    wrap
                >
                    {title}
                </TextM>

                {showRemoveButton && (
                    <TouchableOpacity
                        onPress={() => onRemove?.(item)}
                        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
                        style={{ paddingLeft: 10 }}
                    >
                        <Icon
                            source="times"
                            size={22}
                            color={theme.colors.primary}
                        />
                    </TouchableOpacity>
                )}
            </View>

            {selectOptions.length > 0 && (
                <SelectInputM
                    options={selectOptions}
                    value={selectedValue}
                    onSelect={onSelectChange}
                    style={{ marginTop: 10 }}
                    errors={errors}
                    name={name}
                    sliderLabel={selectLabel}
                    placeholder={selectPlaceholder}
                    noLabel
                />
            )}
        </View>
    )
}

export default SelectableRowWithInput
